// extracted by mini-css-extract-plugin
export default {"create_item":"authorsAdmin_create_item__MMSUZ","image":"authorsAdmin_image__SbF+t","image_item":"authorsAdmin_image_item__n8fTE","delete_item":"authorsAdmin_delete_item__tVhtM"};